
import { Helmet } from "react-helmet";

const SwedishPrivacyPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Integritetspolicy - Lainasampo.fi</title>
        <meta name="description" content="Integritetspolicy för Lainasampo.fi lånejämförelsetjänst" />
      </Helmet>

      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-blue-800 mb-6">Integritetspolicy</h1>
        
        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500 mb-4">
            Detta är en översättning av vår finska integritetspolicy. Den finska versionen är den juridiskt bindande versionen.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Personuppgiftsansvarig</h2>
          <p>
            Pulaton Oy ansvarar för integriteten i Lainasampo.fi-tjänsten.
            <br />
            Organisationsnummer: 3308199-4
            <br />
            E-post: asiakaspalvelu@lainasampo.fi
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Insamlad information</h2>
          <p>
            Vi samlar in följande information från användare för behandling av låneanbud:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>Namn och kontaktuppgifter (e-postadress, telefonnummer)</li>
            <li>Personlig identifieringsinformation</li>
            <li>Anställnings- och inkomstinformation</li>
            <li>Lånerelaterad information (önskat belopp, syfte, löptid)</li>
            <li>Ekonomisk information (befintliga lån, utgifter)</li>
            <li>Teknisk information (IP-adress, webbläsartyp, enhetsinformation)</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Användning av information</h2>
          <p>
            Vi använder din information för följande ändamål:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>För att behandla din låneansökan</li>
            <li>För att begära låneanbud från våra partnerfinansinstitut</li>
            <li>För att kommunicera med dig om din ansökan</li>
            <li>För att förbättra vår tjänst och användarupplevelse</li>
            <li>För att uppfylla våra juridiska skyldigheter</li>
            <li>För statistisk analys och tjänsteutveckling</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Utlämnande av information</h2>
          <p>
            Vi lämnar ut din information till:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>Våra partnerfinansinstitut i syfte att göra låneanbud</li>
            <li>Tjänsteleverantörer som hjälper oss att driva vår webbplats och tillhandahålla våra tjänster</li>
            <li>Myndigheter när det krävs enligt lag</li>
          </ul>
          <p>
            Information lämnas inte ut för marknadsföringsändamål utan ditt uttryckliga samtycke.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Datasäkerhet</h2>
          <p>
            Vi implementerar lämpliga tekniska och organisatoriska åtgärder för att skydda din personliga 
            information mot obehörig åtkomst, utlämnande, ändring och förstörelse.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">6. Datalagring</h2>
          <p>
            Vi lagrar din information så länge som det är nödvändigt för att uppfylla de ändamål för vilka den 
            samlades in, för att uppfylla juridiska skyldigheter eller för att skydda våra legitima intressen.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Dina rättigheter</h2>
          <p>
            Du har rätt att:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>Få tillgång till dina personuppgifter</li>
            <li>Rätta felaktiga personuppgifter</li>
            <li>Begära radering av dina personuppgifter</li>
            <li>Begränsa eller motsätta dig behandlingen av dina personuppgifter</li>
            <li>Dataportabilitet</li>
            <li>Återkalla ditt samtycke när som helst</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">8. Kontaktinformation</h2>
          <p>
            Om du har några frågor om vår integritetspolicy eller hur vi hanterar dina personuppgifter, 
            vänligen kontakta oss på:
            <br />
            E-post: asiakaspalvelu@lainasampo.fi
          </p>
        </div>
      </div>
    </div>
  );
};

export default SwedishPrivacyPage;
